import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { catalogueSearchAPI } from 'src/api/CatalogueApi';
import FormikSelect from 'src/components/formik/FormikSelect';

const CompanyProductsDropDown = ({
    companyId, productCategory, disabled, ...rest
}) => {
    const [
        products,
        setProducts,
    ] = React.useState([]);

    // API CALL TO CATALOGUE
    const fetchCompanyProducts = useCallback(async () => {
        if (!companyId) {
            return;
        }

        const {
            data: {
                data: {
                    data,
                },
            },
        } = await catalogueSearchAPI({
            where: {
                companyId,
                productCategory,
            },
            select: {
                productId: 1,
            },
        }, [
            companyId,
        ]);

        const companyProducts = [];
        const deDupe = {};

        for (const p of data) {
            const { productId: product } = p;
            if (!deDupe[product._id]) {
                deDupe[product._id] = 1;
                companyProducts.push({
                    label: product.productName,
                    value: product._id,
                });
            }
        }

        setProducts(companyProducts);
    }, [
        companyId,
        productCategory,
    ]);

    // ON COMPANY ID CHANGE
    useEffect(() => {
        fetchCompanyProducts();
    }, [
        companyId,
        fetchCompanyProducts,
    ]);

    // RENDER
    return (
        <FormikSelect
            items={products}
            className="form-control"
            disabled={!companyId || !productCategory || disabled}
            {...rest}
        />
    );
};

CompanyProductsDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    companyId: PropTypes.string,
    productCategory: PropTypes.string,
    disabled: PropTypes.bool,
};

CompanyProductsDropDown.defaultProps = {
    value: '',
    companyId: undefined,
    productCategory: undefined,
    disabled: false,
};

export default CompanyProductsDropDown;
